import { DatePipe, DecimalPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MessagesDates, MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';
import { ListadoProspectosComponent } from './listado-prospectos/listado-prospectos.component';
@Component({
  selector: 'app-prospecto-respuesta',
  templateUrl: './prospecto-respuesta.component.html',
  styleUrls: ['./prospecto-respuesta.component.scss'],
  providers:[ListadoProspectosComponent,MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus, DatePipe, DecimalPipe]
})
export class ProspectoRespuestaComponent   {
  Label_Prospectos=environment.LABEL_PROSPECTOS;
  Label_Prospecto=environment.LABEL_PROSPECTO;
  constructor(private loginService: LoginService,
    private listado:ListadoProspectosComponent) { }



  clickGuard() {
    this.loginService.clickGuard = true;
  }

  ExportTOExcel(){
   this.listado.ExportTOExcel()
  }

}
